module.exports = __webpack_public_path__ + "img/logo.d050d1e8.svg";